export const menuColorPickerWidth = '250px';
export const menuColorPickerPadding = '0';
export const menuColorPickerMargin = '5px';
